import React, { useEffect, useState } from "react";
import Header from "./header/Header";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { NavLink, useParams } from "react-router-dom";
import Footer from "./common/Footer";
import Effects from "./common/Effects";
import PeopleDesc from "./common/PeopleDesc";
import PeopleImage from "./common/PeopleImage";
import $ from "jquery";
import monuments, { doRequest, textmapping } from "../helper";

const Detail = (props) => {
  const [image, setImage] = useState("");
  let { id } = useParams();
  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, [id]);

  const getData = async (id) => {
    let response = await doRequest({}, "GET", `post/postdetail?post_id=${id}`);
    console.log("response is ", response);
    if (+response?.resultFlag === 1) {
      let data = response?.response[0];
      if (data.s3_post_url) {
        let image = data.s3_post_url;
        setImage(image);
      } else {
        let image = data.post_url;
        setImage(image);
      }
    }
  };
  return (
    <>
      <Header lang={props.lang} changeLang={props.changeLang} page={"detail"} />
      {/* <div className="container">
        <div className="tiranga_header">
          <div className="trianga_div">
            <h2 style={{ textAlign: "center" }}>
              {textmapping("Aa Gujarat Ame Banaavyu Che", props.lang)}
          
            </h2>
          </div>
        </div>
      </div> */}
      <div className="container">
        <img
          className="banner_detail"
          //   src="http://res.cloudinary.com/ds4uvg1mz/image/upload/v1667799148/harghartiranga2022/c1uedayjwf0ywfefo2wb.jpg"
          src={image}
        />
      </div>

      <div className="row" style={{ marginBottom: "50px", marginTop: "50px" }}>
        <div className="col-sm-12">
          {/* <ul className="chooseimg_list"> */}
            {/* {monuments?.length > 0 &&
              monuments?.map((img, index) => {
                if (index < 3) {
                  return (
                    <li>
                      <img src={img.imgId} className="rounded" alt="" />
                    </li>
                  );
                } else {
                  return <></>;
                }
              })} */}
            {/* <li>
              <img
                src={
                  props.lang == "gu"
                    ? "/assets/images/gujarat1.jpg"
                    : "/assets/images/english1.jpg"
                }
                className="rounded"
                alt=""
              />
            </li>
            <li>
              <img
                src={
                  props.lang == "gu"
                    ? "/assets/images/gujarat2.jpg"
                    : "/assets/images/english2.jpg"
                }
                className="rounded"
                alt=""
              />
            </li>
            <li>
              <img
                src={
                  props.lang == "gu"
                    ? "/assets/images/gujarat3.jpg"
                    : "/assets/images/english3.jpg"
                }
                className="rounded"
                alt=""
              />
            </li> */}
          {/* </ul> */}
          <NavLink
            to={"/uploadimage/monuments" + window.location.search}
            className="monument_btn"
            // onClick={() => {
            // if (props.page == 'home') {

            // try {
            //     let obj = {
            //         platform: getDeviceType()
            //     }
            //     window.gtag('event', 'choose_monument_home', obj)
            // } catch (error) {

            // }
            // }

            // }}
          >
            <img
              src="/assets/images/monument.svg"
              className="monument_blue"
              alt=""
            />
            <img
              src="/assets/images/monumentwhite.svg"
              className="monument_white"
              alt=""
            />
            {textmapping("Create Selfie")}
          </NavLink>
        </div>
      </div>

      {/* <Effects page={"home"} lang={props.lang} changeLang={props.changeLang} /> */}
      {/* <PeopleDesc /> */}
      {/* <PeopleImage /> */}
      {/* <Footer /> */}
    </>
  );
};

export default Detail;
